<script>
    import QuestionTypes from "../../lib/QuestionTypes";
    import {onMount} from 'svelte';
    import {writable} from 'svelte/store';

    export let mapping;
    export let library_map;
    export let assessment_type;
    export let control;
    export let assessment_control;

    let mappings = writable({
        tags: {},
        answers: {}
    });

    function getLibrarySections(library_id) {
        return assessment_type.report_sections.filter(s => s.library_type == library_id)
    }

    function checkTagMapping(m, section, tag) {
        if (m["tags"][section._id]) {
            return m["tags"][section._id].includes(tag.tag_id)
        } else {
            return false;
        }
    }

    function toggleTagMapping(m, section, tag) {
        if ( checkTagMapping(m, section, tag) ) {
            m['tags'][section._id] = m['tags'][section._id].filter((tag_id) => (tag_id != tag.tag_id))
        } else {
            if (m['tags'][section._id]) {
                m['tags'][section._id] = [...m['tags'][section._id], tag.tag_id]
            } else {
                m['tags'][section._id] = [tag.tag_id]
            }
        }

        $mappings = m;
    }

    function checkAnswerMapping(m, section, answer) {
        return m['answers'][section._id] && m['answers'][section._id].includes(answer.value);
    }

    function toggleAnswerMapping(m, section, answer) {
        if (checkAnswerMapping(m, section, answer)) {
            m['answers'][section._id] = m['answers'][section._id].filter(a => a !== answer.value)
        } else {
            if (m['answers'][section._id]) {
                m['answers'][section._id] = [...m['answers'][section._id], answer.value]
            } else {
                m['answers'][section._id] = [answer.value]
            }
        }

        $mappings = m;
    }

    export let cancelAction = () => {};
    export let saveAction = () => {};
    export let deleteAction = () => {};

    function handleSave() {
        saveAction($mappings)
    }

    onMount(() => {
        if (assessment_control.library_mappings[library_map._id]) {
            $mappings = JSON.parse(JSON.stringify(assessment_control.library_mappings[library_map._id]));
        }
    })
</script>


<div class="modal is-active">
    <div class="modal-background" on:click={cancelAction}></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Define Mapping</p>
            <span class="delete" aria-label="close" on:click|preventDefault={cancelAction}></span>
        </header>
        <section class="modal-card-body">
            <h1 class="title is-2">
                {mapping.text}
            </h1>

            <table class="table is=striped is-fullwidth">
                <thead>
                    <tr>
                        <th>
                            Report Section
                        </th>
                        <th>
                            Answer Mappings
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {#each getLibrarySections(library_map.library_id) as section (section._id)}
                        <tr>
                            <th>{section.section_name}</th>
                            <td>
                                <div class="buttons has-addons">
                                    {#each Object.values(QuestionTypes[control.question_type].buttons) as btn}
                                        <button
                                            class="button {checkAnswerMapping($mappings, section, btn) ? btn.color : ''}"
                                            on:click = {toggleAnswerMapping($mappings, section, btn)}
                                        >
                                            {btn.label}
                                        </button>
                                    {/each}
                                </div>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            <table class="table is=striped is-fullwidth">
                <thead>
                    <tr>
                        <th>
                            Report Section
                        </th>
                        <th>
                            Tag Mappings
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {#each getLibrarySections(library_map.library_id) as section (section._id)}
                        <tr>
                            <th>{section.section_name}</th>
                            <td>
                                <div class="tags">
                                    {#each assessment_type.question_tags as tag (tag.tag_id)}
                                        <span
                                            class="pointer tag is-{tag.color_class}"
                                            class:is-light={!checkTagMapping($mappings, section, tag)}
                                            on:click={toggleTagMapping($mappings, section, tag)}
                                        >
                                                {tag.name}
                                            </span>
                                    {/each}
                                </div>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>

        </section>
        <footer class="modal-card-foot buttons is-right">
            <span class="button" on:click|preventDefault={cancelAction}>Cancel</span>
            <button class="button is-success" on:click={handleSave}>Save</button>
        </footer>
    </div>
</div>